export default "https://cdn-static.gokick.com/assets/09fae944e838c54f14fd77486c4f90b3472cb396/images/Sleep_Web_Bottle.d29a408775b1bc1a14ec87c9335374d5.png";